<script>
    // Import animated counter component
    import Vue3Autocounter from 'vue3-autocounter';

    const STATUS_SURCHARGES = 'TOESLAGEN HERSTEL';
    const STATUSES_SUMMONS = ['Dagvaarding gereed, wordt uitgebracht', 'Dagvaarding uitgebracht'];
    const STATUSES_TO_SETTLE = [
        'Debiteur vertrokken onbekend waarheen. Voorbereiden afwikkelen',
        'Dossier gesloten ivm WSNP/Faill. Voorbereiden afwikkelen ',
        'Geen vervolg gerechtelijk. Voorbereiden afwikkelen',
        'Gevoegd. Voorbereiden afwikkelen',
        'Groepsafwikkeling',
        'Hoofdsom geïncasseerd. Voorbereiden afwikkelen',
        'Op verzoek opdrachtgever gesloten. Voorbereiden afwikkelen.',
        'Periodieke afwikkeling',
        'Saldo tegen finale kwijting ontvangen. Voorbereiden afwikkelen',
        'Voorbereiden afwikkelen',
        'Voorbereiden afwikkeling',
        'Voorstel SHV/TFK ontvangen. Voorbereiden afwikkelen.',
        'Vordering geincasseerd. Voorbereiden afwikkelen',
        'Vordering niet geïncasseerd. Voorbereiden afwikkelen',
        'groepsafwikkeling CJIB',
        'groepsafwikkeling Menzis',
        'groepsafwikkeling overig'
    ];

    export default {
        components: {
            Vue3Autocounter,
        },
        props: {
            data: Object,
        },
        data() {
            return {
                facetAlias: 'status_extern_label',
            };
        },
        computed: {
            facetsSet() {
                return this.data && this.data.facets && this.data.facets.length;
            },
            amounts() {
                const defaultValue = { surcharges: 0, summons: 0, toSettle: 0 };
                if (!this.facetsSet) return defaultValue;
                const facet = this.data.facets.find(f => f.alias === this.facetAlias);
                if (!facet || !facet.options || !facet.options.length) return defaultValue;

                return {
                    surcharges: facet.options.filter(o => o.valueAlias === STATUS_SURCHARGES)
                        .reduce((count, option) => count + option.filteredAmount, 0),
                    summons: facet.options.filter(o => STATUSES_SUMMONS.includes(o.valueAlias))
                        .reduce((count, option) => count + option.filteredAmount, 0),
                    toSettle: facet.options.filter(o => STATUSES_TO_SETTLE.includes(o.valueAlias))
                        .reduce((count, option) => count + option.filteredAmount, 0),
                };
            },
        },
    };
</script>

<template>
    <div class="dashboard-widget">
        <div class="block has-text-centered pt-2">
            <span class="is-size-10 has-text-weight-bold">{{ $store.getters.getText('dashboardWidgetStatusfeatured') }}</span>
        </div>
        <div class="block is-flex is-align-items-center is-justify-content-space-between">
            <span>{{ $store.getters.getText('dashboardWidgetStatusfeaturedSurcharges') }}</span>
            <vue3-autocounter :endAmount="amounts.surcharges" separator="." duration="0.5" />
        </div>
        <div class="block is-flex is-align-items-center is-justify-content-space-between">
            <span>{{ $store.getters.getText('dashboardWidgetStatusfeaturedSummons') }}</span>
            <vue3-autocounter :endAmount="amounts.summons" separator="." duration="0.5" />
        </div>
        <div class="block is-flex is-align-items-center is-justify-content-space-between">
            <span>{{ $store.getters.getText('dashboardWidgetStatusfeaturedTosettle') }}</span>
            <vue3-autocounter :endAmount="amounts.toSettle" separator="." duration="0.5" />
        </div>
    </div>
</template>
